import { Component } from '@angular/core';

import {
  AnimatedSuccessCheckComponent,
  DurationComponent,
  ExpandableTextComponent,
  HourDateLineComponent,
  MegaoctetComponent,
  ProgressBarComponent,
  ProgressBarDataComponent,
  ProgressCircleComponent,
  StatComponent,
  StepProgressComponent,
  TimeAgoComponent,
  TrigramComponent,
} from '@camelot/ui';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [
        AnimatedSuccessCheckComponent,
        DurationComponent,
        ExpandableTextComponent,
        HourDateLineComponent,
        MegaoctetComponent,
        ProgressBarComponent,
        ProgressBarDataComponent,
        ProgressCircleComponent,
        StatComponent,
        StepProgressComponent,
        TestIdDirective,
        TimeAgoComponent,
        TrigramComponent,
    ],
    template: `
    <cam-stat camTestId="cam-stat" title="Total" value="42" />
    <cam-progress-bar camTestId="cam-progress-bar" [current]="3" [max]="10" />
    <cam-progress-circle camTestId="cam-progress-circle" />
    <cam-progress-bar-data camTestId="cam-progress-bar-data" title="Usage" [current]="3" [max]="10" />
    <cam-megaoctet camTestId="cam-megaoctet" [octet]="1048576" />
    <cam-duration camTestId="cam-duration" [startDate]="this.start" [endDate]="this.end" />
    <cam-time-ago camTestId="cam-time-ago" [date]="this.start" />
    <cam-trigram camTestId="cam-trigram" value="John Doe" />
    <cam-hour-date-line camTestId="cam-hour-date-line" [startDate]="this.startDate" [endDate]="this.endDate" />
    <cam-expandable-text camTestId="cam-expandable-text">
      Long text content that should be expandable when it exceeds the configured height limit.
    </cam-expandable-text>
    <cam-animated-success-check camTestId="cam-animated-success-check" />
    <cam-step-progress camTestId="cam-step-progress" />
  `
})
export class UiInfoCase {
  public end = '2026-01-02T10:00:00Z';
  public endDate = new Date('2026-01-02T10:00:00Z');
  public start = '2026-01-01T10:00:00Z';
  public startDate = new Date('2026-01-01T10:00:00Z');
}
